import React from "react";
import { ComonIcons } from "../../contents/commonIcons";
import {
    FormGroup,
    Label,
    Row,
    Col,
    Input,
    Modal,
    ModalBody,
  } from "reactstrap";
import Title from "../title";

export const MemberInfoModal = ({ isMemberInfoModalOpen, setIsMemberInfoModalOpen, member }) => {

  const toggle = () => {
    setIsMemberInfoModalOpen(false);
  };

  return (
    <>
        <Modal
            isOpen={isMemberInfoModalOpen}
            centered={true}
            size={"lg"}
            autoFocus={false}
            className="large-pop adding-popup"
            toggle={toggle}
        >
            <ModalBody>
            <div className="bg-white mx-2">
                <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
                <div className="d-inline-flex ">
                    <Title title="Member Info" />
                </div>
                <div className="d-inline-flex ml-auto">
                    <div className="close-icons pb-0">
                    <div className="text-right">
                        <span
                        className="svg-block"
                        onClick={toggle}
                        >
                        {ComonIcons.closeBlack}
                        </span>
                    </div>
                    </div>
                </div>
                </div>
                <div
                className="member-info-wrapper info-wrapper blk-padding-y"
                style={{
                    height: "65vh",
                    maxHeight: "65vh",
                    textAlign: "center",
                }}
                >
                <div className="info trainer-info h-100">
                    <Row
                    style={{ flexDirection: "row", justifyContent: "center" }}
                    >
                    <Col md={6}>
                        <FormGroup className="custom-inputs">
                        <Input
                            type="text"
                            name="memberName"
                            maxLength={50}
                            disabled={true}
                            value={member.name}
                            className={`form-control`}
                        />
                        <Label for="memberName">Name</Label>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup className="custom-inputs">
                        <Input
                            type="text"
                            name="phoneOrEmail"
                            maxLength={50}
                            disabled={true}
                            value={member.phone ? member.phone : member.email}
                            className={`form-control`}
                        />
                        <Label for="phoneOrEmail">
                            {member.phone ? "Phone" : "Email"}
                        </Label>
                        </FormGroup>
                    </Col>
                    </Row>
                    <Row
                    className="justify-content-center align-items-center"
                    style={{ height: "80%" }}
                    >
                    <img
                        src={
                            member.image
                            ? member.image
                            : require("../../assets/images/no-image_user.jpg")
                        }
                        className="member-img-lg"
                        alt="user"
                    />
                    </Row>
                </div>
                </div>
            </div>
            </ModalBody>
        </Modal>
    </>
  );
};
